import React from "react";

/* eslint-disable max-len */
export default function AdminUserIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} viewBox="0 0 30 30">
            <path
                d="M2.4 24.4c0-4.125 5.5-4.125 8.25-6.875 1.375-1.375-2.75-1.375-2.75-8.25Q7.9 2.4 13.4 2.4t5.5 6.875c0 6.875-4.125 6.875-2.75 8.25 2.75 2.75 8.25 2.75 8.25 6.875z"
                transform="translate(-40 -95) translate(41.6 96.6)"
                fill="#9c9c9c"
                data-name="\u30B0\u30EB\u30FC\u30D7 460"
            />
        </svg>
    );
}
